<template>
  <b-modal size="lg" id="upgrade-modal" centered hide-footer hide-header hide-header-close no-close-on-backdrop no-close-on-esc>
    <div id="close">
      <i class="fas fa-times" @click="close"></i>
    </div>
    <b-row class="mt-3">
      <b-col>
        <img :src="'/img/' + graphic" id="modal-img" />
      </b-col>
      <b-col>
        <h2>Expand Your Features</h2>
        <p>The current plan that you have selected does not include this feature. You can upgrade today to receive even more insight into your business.</p>
        <b-button block variant="danger" :to="'/subscriptions'" class="mt-3">Upgrade Now <i class="fas fa-angle-double-up"></i></b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  props: {
    graphic: null,
    subscribed: null
  },
  methods: {
    close() {
      this.$bvModal.hide('upgrade-modal');
    },
    checkSub() {
      if (!this.subscribed) {
        this.$bvModal.show('upgrade-modal');
      }
    }
  },
  mounted() {
    this.checkSub();
  }
};
</script>
<style lang="scss">
#modal-img {
  width: 100%;
}
#upgrade-modal .modal-body {
  background: linear-gradient(to right, #dc3545, white 50%);
}
#close {
  position: absolute;
  right: 13px;
  top: 6px;
  cursor: pointer;
}
</style>